import { apiPath } from '../../constants';
import {
    axios,
    apiRequestOptions,
    errorRequestHandler,
    transformHttpResponse,
} from 'utils';
import { addSuccessMessage } from "../SnackBar";

export const COMPETITION_CATEGORY_PATCH_REQUEST = 'PATCH_COMPETITION_CATEGORY_REQUEST';
export const COMPETITION_CATEGORY_PATCH_FAILURE = 'PATCH_COMPETITION_CATEGORY_FAILURE';
export const COMPETITION_CATEGORY_PATCH_SUCCESS = 'PATCH_COMPETITION_CATEGORY_SUCCESS';

export const patchCompetitionCategory = (data, id) => {
    return function(dispatch) {
        dispatch(patchRequest());
        return axios(apiRequestOptions(apiPath.COMPETITION_CATEGORY.PATCH, data, {params:{id}}))
            .then(transformHttpResponse)
            .then(response => {
                dispatch(patchSuccess(response.data));
                dispatch(addSuccessMessage('Result successfully changed'));
            })
            .catch(error => transformHttpResponse(error.response))
            .catch(error => {
                dispatch(postFailure(error));
                dispatch(errorRequestHandler(error));
            });
    }
};

const patchRequest = () => ({type: COMPETITION_CATEGORY_PATCH_REQUEST});
const postFailure = error => ({type: COMPETITION_CATEGORY_PATCH_FAILURE, error});
const patchSuccess = result => ({type: COMPETITION_CATEGORY_PATCH_SUCCESS, result});
